function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./node_modules/yup/node_modules/@babel/runtime/helpers/interopRequireDefault.js
// module id = 10
// module chunks = 0